import React, { FC, ReactNode } from 'react';
import { SettingsPanel } from './settingsPanel/SettingsPanel';
import styles from './barStyles.module.scss';

export const RightBar: FC<{ formConfigSettingPanel: ReactNode }> = ({ formConfigSettingPanel }) => {
  return (
    <div className={styles.toolboxContainer}>
      <SettingsPanel formConfigSettingPanel={formConfigSettingPanel} />
    </div>
  );
};
